import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';

const searchCommunityLink = '/smarthelp/search-community';

function requestCommunityResults() {
  return {
    type: types.REQUEST_COMMUNITY_RESULTS,
  };
}

function receiveCommunityResults(results) {
  return {
    type: types.RECEIVE_COMMUNITY_RESULTS,
    payload: {
      results,
    },
  };
}
function receiveCommunityResultsError() {
  return {
    type: types.RECEIVE_COMMUNITY_ERROR,
  };
}

export default function getCommunityResults(options) {
  return (dispatch) => {
    dispatch(requestCommunityResults());
    const query = options && encodeURIComponent(options.title);
    const faqID = options && options.id;
    const communityLink = `${searchCommunityLink}?q=${query}&id=${faqID}`;

    return axios.get(communityLink)
      .then((response) => {
        const results = _get(response, 'data');

        if (Array.isArray(results) && results.length > 0) {
          dispatch(receiveCommunityResults(results));
        } else {
          dispatch(receiveCommunityResultsError());
        }
      })
      .catch(() => {
        dispatch(receiveCommunityResultsError());
      });
  };
}
